import Vue from "vue";

export const complianceEventBus = new Vue();

export class ComplianceBlockError extends Error {
  constructor(blockedResult) {
    super("COMPLIANCE_BLOCK");
    this.name = "ComplianceBlockError";
    this.blockedResult = blockedResult;
    this.isComplianceBlock = true;
  }
}

export function extractComplianceBlockedResult(payload) {
  if (!payload || payload.status !== "200" || !payload.data) {
    return null;
  }

  const data = payload.data;
  return data && data.decision === "BLOCK" ? data : null;
}

export function getComplianceIdentifiers(blockedResult) {
  const data = blockedResult && blockedResult.response && blockedResult.response.data;
  return {
    detectionId: data && data.detectionId,
    engineLogId: data && data.logId,
    originalBizId: blockedResult && blockedResult.originalBizId
  };
}

export function handleComplianceResponse(payload) {
  const blockedResult = extractComplianceBlockedResult(payload);
  if (blockedResult) {
    complianceEventBus.$emit("compliance-block", blockedResult);
    throw new ComplianceBlockError(blockedResult);
  }
}



// WEBPACK FOOTER //
// ./src/utils/compliance.js